export default class EsriLayer {
    public id = '';
    public name = '';
    public parentLayerId = 0;
    public defaultVisibility = false;
    public subLayerIds: string = null;
    public minScale = 0;
    public maxScale = 0;
    public type = '';
    public geometryType = '';

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model.name) {
            this.name = model.name;
        }
        if (model.parentLayerId) {
            this.parentLayerId = model.parentLayerId;
        }
        if (model.defaultVisibility) {
            this.defaultVisibility = model.defaultVisibility;
        }
        if (model.subLayerIds) {
            this.subLayerIds = model.subLayerIds;
        }
        if (model.minScale) {
            this.minScale = model.minScale;
        }
        if (model.maxScale) {
            this.maxScale = model.maxScale;
        }
        if (model.type) {
            this.type = model.type;
        }
        if (model.geometryType) {
            this.geometryType = model.geometryType;
        }
    }
}
